import { useMemo } from "react";

import { useDealPipelineData } from "@/hooks/deals/useDealPipelineData";
import { usePortfolioSeedData } from "@/hooks/portfolio/usePortfolioSeedData";
import { getAriClientPortfolioEntityId } from "@/mockData/ariPortfolio";
import { FinancialsTab } from "@/views/portfolio/financials";

export function AriClientFinancialsPanel({ clientId }: { clientId: string }) {
  const entityId = getAriClientPortfolioEntityId(clientId);
  const { seedEntities, seedDealMap, seedTransactions } = usePortfolioSeedData();
  const { initialDeals } = useDealPipelineData();

  const entity = useMemo(
    () => seedEntities.find((item) => item.id === entityId) ?? null,
    [entityId, seedEntities],
  );

  const deals = useMemo(() => {
    if (!entityId) return [];
    const dealIds = seedDealMap[entityId] ?? [];
    return initialDeals.filter((deal) => dealIds.includes(deal.id));
  }, [entityId, initialDeals, seedDealMap]);

  const transactions = useMemo(() => {
    if (!entityId) return [];
    return seedTransactions[entityId] ?? [];
  }, [entityId, seedTransactions]);

  if (!entityId || !entity) {
    return (
      <p className="text-sm text-muted-foreground">
        Financial records are not linked for this client in the demo yet.
      </p>
    );
  }

  return (
    <FinancialsTab
      transactions={transactions}
      entity={entity}
      deals={deals}
      dealMap={seedDealMap}
    />
  );
}
